import { z } from 'zod';

/**
 * A boolean that survives a query string. `z.coerce.boolean()` cannot be used
 * here: it is `Boolean(value)`, so the string `"false"` coerces to **true** and
 * `?includeInactive=false` silently means the opposite of what it says. This
 * reads the two spellings a query string can carry and rejects anything else.
 */
export const queryBooleanSchema = z
  .union([z.boolean(), z.enum(['true', 'false'])])
  .transform((value) => value === true || value === 'true');
